import { Injectable } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';

/**
 * OverlayContainer exclusivo de cada ISDialogComponent.
 *
 * MatMenu/MatSelect/MatTooltip criados pelo componente e respetivos filhos
 * podem acompanhar o dialog para o documento Picture-in-Picture sem mover
 * o OverlayContainer global (usado pelas restantes janelas do CRM).
 *
 * Nota: isto não altera os dispatchers e serviços globais de teclado,
 * scroll ou foco do Angular CDK; consulte o README de limitações.
 */
@Injectable()
export class ISDialogPipOverlayContainer extends OverlayContainer {
  moveTo(targetDocument: Document): void {
    const container = this.getContainerElement();
    if (container.ownerDocument !== targetDocument || container.parentNode !== targetDocument.body) {
      targetDocument.body.appendChild(container);
    }
  }
}
